// @ts-nocheck
import React from "react";
import PropTypes from "prop-types";

import facebook from "./assets/facebook.svg";
import twitter from "./assets/twitter.svg";
import linkedin from "./assets/linkedin.svg";

import styles from "./styles.css";

export default function SocialShare({ url }) {
    return (
        <div className={styles.social}>
            <div className={styles.share}>
                <a
                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}&utm_medium=organic_social&utm_source=linkedin&utm_campaign=blog_share`}
                    target={"_blank"}
                    rel={"noreferrer"}
                >
                    <img src={linkedin} alt={"linkedin"} />
                </a>
            </div>
            <div className={styles.share}>
                <a
                    href={`https://twitter.com/intent/tweet?url=${url}&utm_medium=organic_social&utm_source=twitter&utm_campaign=blog_share`}
                    rel={"noreferrer"}
                    target={"_blank"}
                >
                    <img src={twitter} alt={"twitter"} />
                </a>
            </div>
            <div className={styles.share}>
                <a
                    data-url={url}
                    href={`https://www.facebook.com/sharer.php?u=${url}&utm_medium=organic_social&utm_source=facebook&utm_campaign=blog_share`}
                    target={"_blank"}
                    rel={"noreferrer"}
                >
                    <img src={facebook} alt={"facebook"} />
                </a>
            </div>
        </div>
    );
}

SocialShare.propTypes = {
    url: PropTypes.string,
};
